export default __webpack_public_path__ + "static/media/phoneSmall47.e865864e.svg";